export default __webpack_public_path__ + "static/media/mic.96ebce97.svg";